export default {"src":"/_next/static/media/cescta_combolog-bg.cbdc0787.svg","height":149,"width":266,"blurWidth":0,"blurHeight":0};